var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../../../ui/theme';
import { query } from '../../../const/customBreakPoints';
export var SelectWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  max-width: 375px;\n  width: 100%;\n  padding: ", "px ", "px ", "px;\n\n  @media ", " {\n    margin: 0 auto;\n    width: 90%;\n  }\n"], ["\n  color: ", ";\n  max-width: 375px;\n  width: 100%;\n  padding: ", "px ", "px ", "px;\n\n  @media ", " {\n    margin: 0 auto;\n    width: 90%;\n  }\n"])), theme.black, spacing.base, spacing.base, spacing.base, query.lessThanMedium);
var templateObject_1;
